import { readLatin1String, readUInt16LE, readUInt32LE, readUInt8 } from "../buffer-io";
import type { ChannelDefinition } from "./types";
import { resolveChannelUnits } from "./decode";

export const CHS_PAYLOAD_BYTES = 112;

const INTERPOLATE_DECODERS = new Set([1, 6, 20]);

export function parseChsPayload(payload: Buffer): ChannelDefinition {
  if (payload.length < CHS_PAYLOAD_BYTES) {
    throw new Error(`CHS payload too short (${payload.length} bytes, expected ${CHS_PAYLOAD_BYTES})`);
  }

  const index = readUInt16LE(payload, 0);
  const hardwareId = readUInt16LE(payload, 4);
  const sourceChannelId = readUInt16LE(payload, 6);
  const unitTypeByte = readUInt8(payload, 12);
  const decoderType = readUInt8(payload, 20);
  const shortName = readLatin1String(payload, 24, 8);
  const longName = readLatin1String(payload, 32, 24);
  const samplePeriodUs = readUInt32LE(payload, 64);
  const dataSize = readUInt8(payload, 72);
  const { unit, decimals } = resolveChannelUnits(unitTypeByte);

  return {
    index,
    shortName,
    longName,
    unit,
    decimals,
    decoderType,
    dataSize,
    samplePeriodUs,
    samplePeriodMs: samplePeriodUs / 1000,
    hardwareId,
    sourceChannelId,
    interpolate: INTERPOLATE_DECODERS.has(decoderType),
  };
}

